<template>
  <svg id="Layer_1"
       version="1.1"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0px"
       y="0px"
       width="100px"
       height="100px"
       viewBox="0 0 100 100"
       enable-background="new 0 0 100 100"
       xml:space="preserve">
    <image
      id="image0"
      width="100"
      height="100"
      x="0"
      y="0"
      xlink:href="
      data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACi1BMVEUAAACMXnlVPWlcSXNI
      PGtcSXONXHsAAABaQGtPP25dQGtWRHFVRHHXztdfRG/Xy9XYy9VRQnBVQm5WQ29qUnjOdYFIR3f/
      //9sbJD///9SUH7///9EQ3P///+ZmZn///+Vlar///+Ghqb///+VY4DRf4mSbX/bkpK0KTpPQW+5
      N0hqSnLEVmVHPm23LkBpaY7////p6O////++vc7///9TUoD///9aRXDBTFuAgICqqqpWRnG7O0ti
      Q23EU2FTS3fjrbOUlK7///9gYIj///9VVID///9KSXj////////jrrS8PE26Okr/gIDBSln/////
      //////+2Lj/DV2O0Jznjjo7QhI7///////////+8P068QE+6OEm7PUzBS1u/TVq7PEy6PU3BTVy7
      OUm7OUrRf5K+RVS9QFC4M0S4M0O9QU/RiZI8O25tbJLt7fGhoLlRUH7Oztr////a2uRjY4tkY4u/
      v8/t7PGXl7JFRHXR0d3PztthYIn29vjk5Ovk4+uamrRLSnnCwtI/PnBwb5Wko7unpr1IR3eRka3I
      yNZ5eJtwb5Tb2uSIiKewsMS5ucuzs8b5+fpCQXKzs8dqaZD8/P3GXWpXVoLn5+2yIjTq6u+zssaJ
      iKdzcpdBO21dXYdOTXxgYIlOTXu8vM2FhKTw8PTX1+GCgaJ8e56qqcCLiqnY1+FaWoWLi6ng4OjY
      2OLh4OjOzttbWoVUVICqqb+Mi6nz8/bMy9jn5u3U1N+CgqKdnbfLy9ipqcBXV4J/f6De3ebV1N9U
      U4BeXYeFhaSIh6fFxdSOjqveoalnZo7h4eh2dZmFhaXm5u3p6e+Rka6trcLS0d22tsmUlLCwr8Se
      nbe7O0uyIzSyIzXgyE5fAAAAbHRSTlMAVH7T/tJTAXz5fKysgXzX1+TCwWBT9eVOOcix/fEFAhgO
      KBokHA4H/djQYFb8919Hyafjx8ivgngEA7ekenHy2xMKeF63n/rfYN2qowJ4zchJ+VX+CRsbDTq3
      tNnGc3SioHTw8Bx6wPn6wRz4hLS8AAAAAWJLR0QXC9aYjwAAAAd0SU1FB+QMGBMvBvRD4TQAAAZd
      SURBVGje5Zr3fxRFFMBHRBE7KqIiIioWxIaKiAoaNQas2AtYULFNyN2LhTvv0u5CipCy5iCXEC+Y
      jUFjSTTGEBU1ooJ6Vix/jrO7U95edjfXNr/4+EBmmPfmuzvvzXuzuyEkWzlsxuEzqZSZR8w4MmvT
      rGTWUbOpo8w+uliEY+Sc5U6gY2cVjDgOz7cZtSsCqn18QYgTglAZfNma6ZVgJQSDfNpXg/BacIvV
      DgWDcGLeiDmUhgFC4npDAK/Li98CEJGdKETpnLwQJxnmVWFQqwLhatmuiUKtGqgztE7OGXEKjXFX
      x8VUce55c6Ce0q0S0sD+GDI3N8aplKqrprS2FnWqcCw04g7MywFxmmmBrJvq8FSo3Qw2CMDp2TLO
      MJaDGchtEQXmWS5vsIF60dnGOg02CMzPjnEmN6iUxiEUY8bEeNrt9jsBWJAF4ixu0IKc0hoItMpO
      NW2T7Xgzbc+EACycinE209WQHb5QWwcr0TdtEFjkzTiHqXa0IvMEdem0dkyOBQGBc70Y5xnxwkQs
      SLXR4UkqYLTFErYZnWbBZm2Tv0PKYnfG+YZmDGCnvMR6u5dlWNGdADHZ6YRO82dSyQWuEFMz0lXX
      Lc2juzBklwxk2l3XFVEDPZAJSbox3jI1eyhNGT97uXt3i6l2c2+b0ZwyFdkiUivPaJmQC50ZF9H4
      224ur0HtPjzQhTsYklzixLhY1/vf0Qcs9ZCug65zl+/R+1iHT8QG3tV5Lkjp76mBTEhyqaNDBgFk
      jmpgEfM+cr+6YpZjPhDtcsD+z4A4uOUStkFw9mi3x5XKtt32gQ+pK+TSTMZlTOcjVlalwRbaLNs1
      ITokO8M0IEtMbYSlH4y0y+VO0culArU/xgOduPMJao84Q8DOuAKlohCuEduQX22V5NMwHtCcIcts
      EIB+YTAKygMRQ1PwP2PtJnkhTFJiZYGbg+etXGl3ptoVATzQBWNYS5XkCq41GXIVvpHQoIxEbW+D
      mjjcUa/8H6UqrYx/Xv6FAnJz8LqVqymqDyKKv8T9fVzDmCtCkboIEs0FsnxSaDXaailqhypRpyrk
      ouUEkbdyjaWyFdAZIQrqjGCcHWBQhJvR4QWr1mirJczcjKasyLiRXuzMYUjgS/xKtrfbg0R5xhnC
      k8u10vzr6gFlPqDm0hJtald805JQ6Qp0mAqy0oRcxx1q5BEzlMzCGLNqhSmsckwYP81/ArySxKz/
      iIm2G+R6uVoj2H/4lPNtBHWiWKsbtUc8IEkOYTWiW++xFANmJeGXtl8f6hQFI8YGvtMneCzo3bYS
      Y5m7Q25go5tRLk+hTEK/V5mEaoCeSX5AiUiaO0NWMchqqvKC5cyEMmdpZZ/s9CdscaWWWJgfcJQb
      uUsGaUjuQ60DVfQmo37IuehBuQ/HG6gKOGEOzmKvJHgr0x9xJ47atkcSfNp0h9yElOpwucIbII4P
      JRBw0XKDlJCbpcoEyiS0D2WSWEJlEjqOM8kYflhxhdxCblU6GnZ/GNqxdUS2M9IK3i4ukFJyG1rf
      nxrVeieoirGOlpR6WGnvbVIZbkiDqSFl3O9mzopx14ur1vhfWTx+RgOmiEgZ8IQAh+BMYnvubcXP
      vfiqO3CQcfOki5iQdBp+SfODdU+6H9LixLY3DaPpX612LdNKp/lN/JZuh7Q4bkpzTwj9HTmTuf8P
      2fkTUMC2o8NqRD0DKXNvSLQPR8ywKraHxtDJFQ4prUhiVNVqYe4NYfnpoLDYw9Zbmu9HG1yLUfXM
      znbHX7IjzL0hRZL/AQSmQUiZ/4wyUuo/pJSs8R+yhpT4Dykh0+B5Mk2QtQd8lrUMsirpsxiHO+I3
      hEwb5HZ/GXeYkJX+Qu4k07Be/JlxhZ+Mu9RLD193oiXL/WOolwU+3gp6t3K3X4x77K+ifL8RQpb5
      w7C/VPPpVjLeQa7zg7Eu83XqvcXfh5Ne2fqRXCYzyNJiM+5zgJAlxWU4fhAg5P5iMlw+bRTXLW4M
      8kDxGO6fm8jiHUWSB4mHPFScXej5CZCQRcVgPEymkIWFM6b8LMtkQWGIbD4wM5lfCCPLT+WEPJI/
      I+uP/kzm5YfI5dcXmMz9Ow/J8RcxmDya6yZ/LGeEIetzQazPC2HIhmwRG/JGGPL4P1MT/n2iIIQp
      T3ojniqcYMnGp50Bz2wsFoHLs5uee15N/8KLm17K2vQ/u74SutXlJFcAAAAldEVYdGRhdGU6Y3Jl
      YXRlADIwMjAtMTItMjRUMTk6NDc6MDYrMDM6MDAkuJ60AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIw
      LTEyLTI0VDE5OjQ3OjA2KzAzOjAwVeUmCAAAAABJRU5ErkJggg==" />
  </svg>
</template>

<script>
export default {
  name: 'En',
};
</script>

<style lang="scss" scoped>
</style>
